import { MAIN_REPORT } from './enums';

/**
 * Clase que acumula todas las constantes internas de la aplicación (idiomas disponibles, referencias globales de llamadas rest...)
 */
export class Constants {
  /**
   * Constante que determina los tipos de empleado
   *
   * @static
   * @memberof Constants
   */
  public static employeeType = [
    { codigo: 1, nombre: 'EXTERNO' },
    { codigo: 0, nombre: 'INTERNO' },
  ];

  public static enabledStatus = 'enabled';
  public static blockedStatus = 'blocked';


  public static months = [
    { name: 'MES.ENERO', code: '01' },
    { name: 'MES.FEBERO', code: '02' },
    { name: 'MES.MARZO', code: '03' },
    { name: 'MES.ABRIL', code: '04' },
    { name: 'MES.MAYO', code: '05' },
    { name: 'MES.JUNIO', code: '06' },
    { name: 'MES.JULIO', code: '07' },
    { name: 'MES.AGOSTO', code: '08' },
    { name: 'MES.SEPTIEMBRE', code: '09' },
    { name: 'MES.OCTUBRE', code: '10' },
    { name: 'MES.NOVIEMBRE', code: '11' },
    { name: 'MES.DICIEMBRE', code: '12' }
  ];

  /**
   * Constante que determina los Generos
   *
   * @static
   * @memberof Constants
   */
  public static objectOReportsfButtons = {
    administration: [
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportAdmin,
        divitions: false,
        label: 'EXPORT.EXPORTAR_ADMIN'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportAdminHours,
        divitions: false,
        label: 'EXPORT.EXPORTAR_ADMIN_HOURS'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportEmployeeHours,
        divitions: false,
        label: 'EXPORT.EXPORTAR_ADMIN_EMPLOYE'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportResponsibleOpenModal,
        divitions: true,
        label: 'EXPORT.EXPORTAR_RESPONSIBLE'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportIncidents,
        divitions: false,
        label: 'EXPORT.INCIDENTS'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportProjectFeesEmployee,
        divitions: false,
        label: 'EXPORT.PROJECT_FEES_EMPLOYEE'
      },
    ],
    operations: [
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportOpenModalClient,
        divitions: true,
        label: 'EXPORT.EXPORTAR_OPE_CLIENTE'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportOpenModalEmployee,
        divitions: true,
        label: 'EXPORT.EXPORTAR_OPE_EMPLEADO'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportNotImputed,
        divitions: false,
        label: 'EXPORT.EXPORTAR_NO_IMPUTADOS'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportInterventionHoursControl,
        divitions: false,
        label: 'EXPORT.EXPORTAR_INTERVENTIONS'
      },
            {
        cleanFromModal: false,
        type: MAIN_REPORT.exportGuards,
        divitions: false,
        label: 'EXPORT.EXPORTAR_GUARDS'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportOpenModalDesvWorkingDay,
        divitions: true,
        label: 'EXPORT.EXPORTAR_DESV_WORKINGDAY'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportExtraHours,
        divitions: true,
        label: 'EXPORT.EXTRA_HOURS'
      },
      {
        cleanFromModal: false,
        type: MAIN_REPORT.exportResponsibleOpenModal,
        divitions: true,
        label: 'EXPORT.EXPORTAR_RESPONSIBLE'
      },
    ]
  };

  /**
   * Constante que determina los Generos
   *
   * @static
   * @memberof Constants
   */
  public static gender = [
    { codigo: 0, nombre: 'DESCONOCIDO' },
    { codigo: 1, nombre: 'VARON' },
    { codigo: 2, nombre: 'HEMBRA' },
    { codigo: 9, nombre: 'NOAPLICA' },
  ];

  /**
   * Constante que determina los tipos de via
   *
   * @static
   * @memberof Constants
   */
  public static via = [
    { codigo: '01', nombre: 'AVENIDA' },
    { codigo: '02', nombre: 'CALLE' },
    { codigo: '03', nombre: 'CALLEJON' },
    { codigo: '04', nombre: 'CAMINO' },
    { codigo: '05', nombre: 'CARRETERA' },
    { codigo: '06', nombre: 'GLORIETA' },
    { codigo: '08', nombre: 'PASEO' },
    { codigo: '09', nombre: 'PLAZA' },
    { codigo: '10', nombre: 'POLIGONO' },
    { codigo: '11', nombre: 'RAMBLA' },
    { codigo: '12', nombre: 'RESIDENCIA' },
    { codigo: '13', nombre: 'RONDA' },
    { codigo: '14', nombre: 'TRAVESIA' },
    { codigo: '15', nombre: 'URBANIZACION' },
    { codigo: '16', nombre: 'VIA' },
  ];

  /**
   * Constante que determina las provincias
   *
   * @static
   * @memberof Constants
   */
  public static province = [
    { codigo: 'alava', nombre: 'Álava' },
    { codigo: 'albacete', nombre: 'Albacete' },
    { codigo: 'alicante', nombre: 'Alicante' },
    { codigo: 'almeria', nombre: 'Almería' },
    { codigo: 'asturias', nombre: 'Asturias' },
    { codigo: 'avila', nombre: 'Ávila' },
    { codigo: 'badajoz', nombre: 'Badajoz' },
    { codigo: 'barcelona', nombre: 'Barcelona' },
    { codigo: 'burgos', nombre: 'Burgos' },
    { codigo: 'caceres', nombre: 'Cáceres' },
    { codigo: 'cadiz', nombre: 'Cádiz' },
    { codigo: 'cantabria', nombre: 'Cantabria' },
    { codigo: 'castellon', nombre: 'Castellón' },
    { codigo: 'ceuta', nombre: 'Ceuta' },
    { codigo: 'ciudadreal', nombre: 'Ciudad Real' },
    { codigo: 'cordoba', nombre: 'Córdoba' },
    { codigo: 'acoruña', nombre: 'Coruña' },
    { codigo: 'cuenca', nombre: 'Cuenca' },
    { codigo: 'girona', nombre: 'Girona' },
    { codigo: 'guadalajara', nombre: 'Guadalajara' },
    { codigo: 'guipuzcoa', nombre: 'Guipúzcoa' },
    { codigo: 'huelva', nombre: 'Huelva' },
    { codigo: 'huesca', nombre: 'Huesca' },
    { codigo: 'illesbalears', nombre: 'Islas Baleares' },
    { codigo: 'jaen', nombre: 'Jaén' },
    { codigo: 'larioja', nombre: 'La Rioja' },
    { codigo: 'laspalmas', nombre: 'Las Palmas' },
    { codigo: 'granada', nombre: 'Granada' },
    { codigo: 'leon', nombre: 'León' },
    { codigo: 'lleida', nombre: 'Lleida' },
    { codigo: 'lugo', nombre: 'Lugo' },
    { codigo: 'madrid', nombre: 'Madrid' },
    { codigo: 'malaga', nombre: 'Málaga' },
    { codigo: 'melilla', nombre: 'Melilla' },
    { codigo: 'murcia', nombre: 'Murcia' },
    { codigo: 'navarra', nombre: 'Navarra' },
    { codigo: 'ourense', nombre: 'Ourense' },
    { codigo: 'palencia', nombre: 'Palencia' },
    { codigo: 'pontevedra', nombre: 'Pontevedra' },
    { codigo: 'salamanca', nombre: 'Salamanca' },
    { codigo: 'segovia', nombre: 'Segovia' },
    { codigo: 'sevilla', nombre: 'Sevilla' },
    { codigo: 'soria', nombre: 'Soria' },
    { codigo: 'tarragona', nombre: 'Tarragona' },
    { codigo: 'santacruztenerife', nombre: 'Santa Cruz de Tenerife' },
    { codigo: 'teruel', nombre: 'Teruel' },
    { codigo: 'toledo', nombre: 'Toledo' },
    { codigo: 'valencia', nombre: 'Valencia/València' },
    { codigo: 'valladolid', nombre: 'Valladolid' },
    { codigo: 'vizcaya', nombre: 'Vizcaya' },
    { codigo: 'zamora', nombre: 'Zamora' },
    { codigo: 'zaragoza', nombre: 'Zaragoza' },
  ];

  public static urlBase = {
    localDev: 'https://ess.ciber.es',
  };

  /**
   * El prefijo que se le va a añadir a las traducciones de los errores para localizarlos en las traducciones globales de la app
   */
  public static readonly errorTranslatePrevix = 'COMMON.CUSTOM_ERRORS.';
  /**
   * Constante que contiene la coleccion de las llamadas rest
   */
  public static restConn = {
    baseUrl: '',
    rest1: 'http://localhost/test.php',
    rest2: 'https://jsonplaceholder.typicode.com/posts/2',
    customer: 'assets/mocks/customer.json',
    /* SE SUPONE QUE CON LOS MOCKS ESTO YA NO SE USA
    accounts: 'assets/config/accounts.json',
    footer: 'assets/config/footer.json',
    header: 'assets/config/header.json',
    operations: 'assets/config/operations.json',
    statements_accounts: 'assets/config/statements_accounts.json'
    */
  };

  /**
   * Constante para los idiomas de la aplicación
   */
  public static readonly languages = {
    codes: ['es-ES', 'en-GB', 'es-CA', 'es-GA'],
    names: [
      'COMMON.LANGUAGE.SPANISH',
      'COMMON.LANGUAGE.ENGLISH',
      'COMMON.LANGUAGE.CATALAN',
      'COMMON.LANGUAGE.GALICIAN',
    ],
    delayLoad: 100,
    delayLockIE: 1000,
    delayLockOthers: 10,
  };

  /**
   * Constante que contiene las rutas internas y externas del dsConfig
   */
  public static dsConfigRoute = {
    dev: './config.json',
    ext: './config.json',
    int: 'assets/config.json?internal=true',
  };

  /**
   * Constante que contiene las rutas internas y externas de Home Banking
   *
   */
  public static dsUrlRoute = {
    dev: './urls.json',
    ext: './urls.json',
    int: 'assets/urls.json?internal=true',
  };

  /**
   * Constantes asociadas al servicio de Tealium
   */
  public static tealiumLayerRoute = {
    int: 'assets/tealium-data-layer.json?internal=true',
  };

  /**
   * Constantes asociadas al UserService
   */
  public static UserData = {
    CUSTOMER: 'CUSTOMER',
    TOKEN: 'Ciber-Token',
    eventForRefresh: 'refreshUserSession',
    eventForReset: 'resetUserSession',
    fieldTimeRest: 'timeoutInterval',
    fromLoginField: 'initApp',
    sid: 'session-ID',
    xclient: 'X-ClientId',
    appinit: 'app-Init',
    operativeLock: 'OPERATIVA',
    blockLock: 'BLOCK',
    email: 'EMAIL',
    profileId: 'PROFILE_ID',
    employeeNumber: 'EMPLOYEE_NUMBER',
    employeeName: 'EMPLOYEE_NAME'
  };

  /**
   * Constante que determina la aplicacion del responsive y el sticky menu
   */
  public static displayOptions = {
    maxWidthResponsiveScroll: 1024,
  };

  /**
   * Constante para definir warnings específicos
   * Si las llamadas vienen sin code y con el error=true, entonces cogerá el error por defecto
   * del id del restConn. Aqui almacenamos esos errores por defecto de las pantallas
   */
  public static customWarnings = {
    products_accounts: 'COMMON.CUSTOM_ERRORS.PRODUCT_ERROR',
  };

  public static defaultCurrency = 'EUR';

  /**
   * Constante que determina el idioma Castellano
   */
  public static spanishLanguage = 'es-ES';

  /**
   * Constante que determina el idioma Private Banking
   */
  public static SPBLanguage = 'es-PB';

  /**
   * Constante que determina los idiomas cuyo calendario empieza en lunes
   *
   * @static
   * @memberof Constants
   */
  public static languagesStartMonday = [
    'es-ES',
    'es-CA',
    'es-GA',
    'es-PB',
    'en-GB',
  ];

  /**
   * From products To summary observatory
   */
  public static productsSummaryObservatoryName =
    'productsSummaryObservatoryConn';

  /**
   * Prefijos españoles
   */
  public static spanishPrefix = ['+0034', '+034', '+34', '0034', '034', '34'];

  /**
   * Operaciones frecuentes
   */
  public static cardList = '0002';

  /**
   * Operaciones estáticas
   */

  public static staticOperations = 'operations_static';

  /**
   * Operaciones frecuentes
   */
  public static asideOperations = 'operations_pb';
  public static blockCardOp = '0022';

  public static formatNumbers = {
    DEFAULT_LANGUAGE: 'es-ES',
    DEFAULT_FORMAT: '1.2-2',
  };

  public static exportService = {
    URL: {
      PDF: '/../export/success/pdf',
      ACCOUNTS_EXCEL: '/../export/accounts/excel',
      ACCOUNTS_PDF: '/../export/accounts/pdf',
      ACCOUNTS_STATEMENT_PDF: '/../export/accounts/statement/pdf',
      STATEMENT_DETAIL: '/../export/statementDetail/pdf',
      PORTFOLIO_STOCKS: '/../export/stocks/portfolio/pdf',
      CARDS_STATEMENT: '/../cards/statement/pdf',
      CARDS_EXCEL: '/../export/cards/excel',
      CARDS_PDF: '/../export/cards/pdf',
    },
  };

  // ********* EXPRESIONES REGULARES PARA DETECCIÓN DE DISPOSITIVOS/NAVEGADORES ********* //

  // Internet Explorer or Edge
  public static isIEOrEdge() {
    return /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  }

  // Internet Explorer
  public static isIE() {
    return /msie\s|trident\//i.test(window.navigator.userAgent);
  }

  // Edge
  public static isEdge() {
    return /edge\//i.test(window.navigator.userAgent);
  }

  // Chrome
  public static isChrome() {
    return /chrom(e|ium)\//i.test(window.navigator.userAgent);
  }

  // Firefox
  public static isFirefox() {
    return /firefox\//i.test(window.navigator.userAgent);
  }

  // Safari on Mac or Mobile
  public static isSafariOrUiwebview() {
    return /(iPhone|iPod|iPad).*AppleWebKit\//i.test(
      window.navigator.userAgent
    );
  }

  // Safari on Mac Only
  public static isSafari() {
    return /^((?!chrome|android).)*safari\//i.test(window.navigator.userAgent);
  }

  // Safari on Mobile
  public static isUiwebview() {
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)\//i.test(
      window.navigator.userAgent
    );
  }

  // Opera
  public static isOpera() {
    return /opera|opr\//i.test(window.navigator.userAgent);
  }

  /**
   * Comprueba si es un dispositivo móvil
   */
  public static isMobile() {
    // detect user agent
    const mobile =
      /iphone|ipod|webos|android|blackberry|mini|iemobile|opera mini|windows\sce|palm\//i.test(
        window.navigator.userAgent.toLowerCase()
      );
    let result = false;

    if (mobile) {
      result = true;
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('android') > -1 && userAgent.search('mobile') > -1) {
        // android mobile
        result = true;
      } else if (
        userAgent.search('android') > -1 &&
        !(userAgent.search('mobile') > -1)
      ) {
        // android tablet
        result = false;
      }
    }
    return result;
  }

  /**
   * Comprueba si es un dispositivo móvil tipo tablet
   */
  public static isTablet() {
    // detect user agent
    const tablet = /ipad|android|mini|windows\sce|palm\//i.test(
      window.navigator.userAgent.toLowerCase()
    );
    let result = false;

    if (tablet) {
      result = true;
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('android') > -1 && userAgent.search('mobile') > -1) {
        result = false;
      } else if (
        userAgent.search('android') > -1 &&
        !(userAgent.search('mobile') > -1)
      ) {
        result = true;
      }
    }
    return result;
  }

  /**
   * Comprueba si es un dispositivo móvil
   */
  public static isMobileDevice() {
    // return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    return this.isMobile() || this.isTablet();
  }
}
